const LogoEximPlanet = ({ width, height, style }) => {
    return (
        <img width={width} height={height} style={style} src="/logo-horizontal.png" alt="" />
    )
}

export default LogoEximPlanet